import Main from '../components/main'

export const routerComponentMap = {
  login: () => import('../view/login/login'),
  dashboard: Main,
  dashboardIndex: () => import('../view/single-page/home/index'),

  system: Main,
  menu: () => import('../view/system/menu'),
  user: () => import('../view/system/user'),
  auth: () => import('../view/system/auth'),

  // ReportAnalysis: Main,
  // InventoryStatistics: () => import('../view/report/good-stock/stock-analysis'),
  // SalesStatistics: () => import('../view/report/sales/sales-statistics'),

  // 活动管理
  activity: Main,
  exhibition: () => import('../view/activity/exhibition'),
  forum: () => import('../view/activity/forum'),
  registerRecord: () => import('../view/activity/register-record'),

  // 会员管理
  member: Main,
  memberList: () => import('../view/member/member-list'),
  orderList: () => import('../view/member/order-list'),
  feedback: () => import('../view/member/feedback'),
  level: () => import('../view/member/level'),

  // 基本设置
  settings: Main,
  memberProtocol: () => import('../view/member/member-protocol'),
  category: () => import('../view/system/category'),

  // 文章设置
  article: Main,
  articleCategory: () => import('../view/article/article-category'),
  articleList: () => import('../view/article/article-list'),
  articleComment: () => import('../view/article/article-comment'),
  notice: () => import('../view/article/notice'),

  // 社区
  community: Main,
  communityList: () => import('../view/community/community-list'),
  communityComment: () => import('../view/community/community-comment'),

  // 通讯录管理
  addressBook: Main,
  addressBookList: () => import('../view/address-book/address-book-list'),
  applyList: () => import('../view/address-book/apply-list'),
  addressBookOrderList: () => import('../view/address-book/order-list')
}
